"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failedImageUrls = void 0;
// Needed for InfiniteList React Admin component
// When the application is running, failedImageUrls keeps track of all image URLs that failed to load.
// Each time an image fails to load, its URL is added to failedImageUrls
// If the same component tries to load an image URL already in failedImageUrls, it avoids re-fetching the image
exports.failedImageUrls = new Set();
